import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { useState } from "react";
import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";

const RestoreCustomerDialog = ({ open, handleClose, onConfirm, loading }) => {
  const theme = useTheme();
  const [errorMsg, setErrorMessage] = useState(null);
  const [confirmText, setConfirmText] = useState(null);

  return (
    <Dialog
      keepMounted
      scroll={"paper"}
      maxWidth="sm"
      fullWidth={true}
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Restore Company Account</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <DialogContentText>
          Please confirm you want to restore this company account. Please enter
          "restore"
        </DialogContentText>
        <TextField
          sx={{ marginTop: "16px" }}
          variant="outlined"
          label="restore"
          name="restore"
          value={confirmText}
          onChange={(e) => {
            setConfirmText(e.target.value);
          }}
          size="large"
        />
      </DialogContent>
      <DialogActions>
        <LoadingButton
          onClick={() => {
            setConfirmText("");
            handleClose();
          }}
          loading={loading}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          variant="contained"
          loading={loading}
          disabled={confirmText != "restore"}
          onClick={onConfirm}
        >
          Confirm
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default RestoreCustomerDialog;
